import { Color, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

export const QuoteStatusHeader = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Styled.QuoteStatusHeaderWrapper>
      <Text variant="bodySM" weight="bold" color={Color.Grey900} uppercase>
        {t('quotes.view.sidebar.details_card.quote_status.header')}
      </Text>
    </Styled.QuoteStatusHeaderWrapper>
  )
}
